module.exports = __webpack_public_path__ + "assets/img/b66a0f34fbe0aff94fc6f7fdc0fd0bdb.png";